<template>
  <i-dropdown @close="editor.chain().clearSearch().run()" @open="searchOpen" v-model:isOpen="open">
    <template v-slot:trigger="{toggle, attrs}">
      <i-button ref="button" :disabled="disabled" @click.prevent="toggle" v-bind="$attrs">
        <i-icon icon="search" :title="__('Search And Replace')"></i-icon>
      </i-button>
    </template>
    <template #default="{ isOpen, close, activeIndex }">
      <ul class="dropdown-menu i-dropdown-menu block">
        <UseFocusTrap 
          v-if="isOpen" 
          :options="{ 
            immediate: true, 
            allowOutsideClick: true,  
            escapeDeactivates: true,
          }">
        <form>
          <div class="form-group">
            <div class="input-container">
              <input
                v-model="searchText"
                @input="editor.chain().search(searchText).run()"
                @keydown.enter.prevent.stop="editor.chain().nextMatch().run()"
                :placeholder="__('Find')"
                name="searchText"
                class="search-input"
                ref="searchInput"
              />
              <i-button
                :class="[{ enabled: matchCase }]"
                @click.prevent.stop="() => { matchCase = !matchCase; editor.chain().setCase(matchCase).run(); editor.chain().search(searchText).run(); }"
                class="input-button"
              >
                <i-icon icon="font-case" :title="__('Match Case')"></i-icon>
              </i-button>
              <i-button
                :class="[{ enabled: matchWholeWord }]"
                @click.prevent.stop="() => { matchWholeWord = !matchWholeWord; editor.chain().setWholeWord(matchWholeWord).run(); editor.chain().search(searchText).run(); }"
                class="input-button"
              >
                <i-icon icon="input-text" :title="__('Match Whole Word')"></i-icon>
              </i-button>
            </div>
            <i-button @click.prevent="editor.chain().prevMatch().run()">
              <i-icon icon="arrow-up" :title="__('Previous Match')"></i-icon>
            </i-button>
            <i-button @click.prevent="editor.chain().nextMatch().run()">
              <i-icon icon="arrow-down" :title="__('Next Match')"></i-icon>
            </i-button>
          </div>

          <div class="form-group">
            <div class="input-container">
              <input 
                v-model="replaceText" 
                @keydown.enter.prevent="() => { editor.chain().replace(replaceText).run(); editor.chain().search(searchText).run(); }"
                :placeholder="__('Replace')" 
                name="replaceText" 
                class="replace-input" 
              />
              <i-button @click.prevent="() => { editor.chain().replace(replaceText).run(); editor.chain().search(searchText).run(); }">
                <i-icon icon="arrows-rotate" :title="__('Replace')"></i-icon>
              </i-button>
              <i-button @click.prevent="() => { editor.chain().replace(replaceText, true).run();}">
                <i-icon icon="repeat" :title="__('Replace All')"></i-icon>
              </i-button>
            </div>
          </div>
        </form>
        </UseFocusTrap>
      </ul>
    </template>
  </i-dropdown>
</template>

<script>
import globals from '@/globals.js'
import Button from '@/components/lib/button/Button.vue'
import Icon from '@/components/lib/icon/Icon.vue'
import Dropdown from '@/components/lib/dropdown/Dropdown.vue'
import { UseFocusTrap } from '@vueuse/integrations/useFocusTrap/component';

export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    UseFocusTrap,
  },
  data() {
    return {
      searchText: '',
      replaceText: '',
      open: false,
      matchCase: false,
      matchWholeWord: false,
    }
  },
  props: {
    editor: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
    }
  },
  mounted() {
    this.$refs.button && (this.button = this.$refs.button.$el || this.$refs.button)
  },
  methods: {
    __(str) {
      return globals.I.gt.__(str)
    },
    searchOpen() {
      this.editor.chain().search(this.searchText).run();

      this.$refs.searchInput.focus();
    },
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.tiptap-select-label {
  margin-right: 15px;
}

/* General dropdown menu style */
.i-dropdown-menu {
  display: block;
  max-height: 120px;
  border-radius: 0px;
  width: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 1000;
}

form {
  display: flex;
  flex-direction: column;
}

.form-group {
  display: flex;
  align-items: center;
  margin: 2px;
}

/* Input styles */
.search-input, .replace-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  outline: none;
}

.search-input:focus, .replace-input:focus {
  border-color: #007bff;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  // width: 100%;;
  // border: 1px solid #ccc;
  // border-radius: 4px;
  // font-size: 14px;
  // outline: none;
}

.i-button {
  width: 26px;

  i {
    margin: 0 auto;
  }
}

.input-button {
  position: absolute;
  right: 2px; /* Adjust based on layout */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  width: 26px;
  padding: 0;
  margin: 0 2px;
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
}  

.input-button:first-of-type {
  right: 30px; /* Adjust spacing for the first button */
}

.i-button.input-button.active {
  background: #FFF;
}

body .i-button.input-button.enabled {
  color: #007bff !important;
}

.input-button i-icon {
  font-size: 16px;
}
</style>
